import React from 'react';
import { PhoneIcon } from 'lucide-react';
const importantNumbers = [{
  label: 'Club Main Line',
  number: '(810) 629-7964'
}, {
  label: 'Emergency',
  number: '911'
}, {
  label: 'Genesee County Sheriff',
  number: '(810) 257-3422'
}];
export function ImportantPhoneNumbers() {
  return <div className="w-full" style={{
    backgroundColor: '#f8f6f0'
  }} data-id="element-2868">
      <div className="max-w-4xl mx-auto px-4 md:px-8 pt-12" data-id="element-2869">
        <h2 className="text-2xl md:text-3xl font-bold uppercase mb-6" style={{
        fontFamily: 'Oswald, sans-serif',
        color: '#1e3d2f'
      }} data-id="element-2870">
          Important Phone Numbers
        </h2>
        <div className="bg-white rounded-xl overflow-hidden shadow-sm border" style={{
        borderColor: '#ede9e0'
      }} data-id="element-2871">
          {importantNumbers.map((item, index) => <div key={item.label} className={`flex items-center gap-4 p-4 ${index < importantNumbers.length - 1 ? 'border-b' : ''}`} style={{
          borderColor: '#ede9e0'
        }} data-id="element-2872">
              <div className="w-10 h-10 rounded-lg flex items-center justify-center flex-shrink-0" style={{
            backgroundColor: 'rgba(30,61,47,0.08)'
          }} data-id="element-2873">
                <PhoneIcon size={18} style={{
              color: '#1e3d2f'
            }} data-id="element-2874" />
              </div>
              <div className="flex-1" data-id="element-2875">
                <p className="text-sm text-gray-500" style={{
              fontFamily: 'Inter, sans-serif'
            }} data-id="element-2876">
                  {item.label}
                </p>
                <a href={`tel:${item.number.replace(/[^\d]/g, '')}`} className="text-base font-semibold hover:underline" style={{
              color: '#1e3d2f',
              fontFamily: 'Inter, sans-serif'
            }} data-id="element-2877">
                  {item.number}
                </a>
              </div>
            </div>)}
        </div>
      </div>
    </div>;
}